export class StatusCode {
    static readonly unauthorized = 401;
}
